<template>
    <div>
        <h1 class="text-center" style="margin-top: 100px">
            Facturation des todo
        </h1>
    </div>
</template>

<script>
export default {
    name: 'TodoBillingHome',

    created() {
        this.$store.commit('reportingVM/RESET_SEARCH')
    },
}
</script>

<style scoped></style>
